import React, { Component, createRef } from 'react';
import { Spinner } from 'react-bootstrap';

export class ConfirmationIframe extends Component {
  constructor(props) {
    super(props);
    this.iframeRef = createRef();
    this.loadingTimer = null;
    this.state = {
      height: 600,
      isLoading: true,
    };
  }

  componentDidMount() {
    window.addEventListener('message', this.handleMessage);
    // Show loader for 3 seconds before displaying iframe
    this.loadingTimer = setTimeout(() => {
      this.setState({ isLoading: false }, () => {
        if (this.props.onResizeComponent) {
          this.props.onResizeComponent();
        }
      });
    }, 3000);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
  }

  handleMessage = (event) => {
    // Listen for height updates from the iframe content
    if (event.data && event.data.type === 'resize' && event.data.height) {
      this.setState({ height: event.data.height }, () => {
        if (this.props.onResizeComponent) {
          this.props.onResizeComponent();
        }
      });
    }
  };

  handleLoad = () => {
    const { onResizeComponent } = this.props;
    // Try to access iframe content height (will only work for same-origin)
    try {
      if (this.iframeRef.current && this.iframeRef.current.contentWindow.document.body) {
        const contentHeight = this.iframeRef.current.contentWindow.document.body.scrollHeight;
        this.setState({ height: contentHeight }, () => {
          if (onResizeComponent) {
            onResizeComponent();
          }
        });
      }
    } catch (e) {
      // Cross-origin, can't access - rely on postMessage from iframe
      console.log('Cannot access iframe content (cross-origin). Iframe should send resize messages.');
    }
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      );
    }

    return (
      <iframe
        ref={this.iframeRef}
        src={this.props.url}
        style={{
          width: '100%',
          height: `${this.state.height}px`,
          border: 'none',
        }}
        onLoad={this.handleLoad}
        title="Order Confirmation"
      />
    );
  }
}
